import { render, staticRenderFns } from "./search_results_summary.vue?vue&type=template&id=f3b8a1a2&"
import script from "./search_results_summary.vue?vue&type=script&lang=js&"
export * from "./search_results_summary.vue?vue&type=script&lang=js&"
import style0 from "./search_results_summary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports